import { render, staticRenderFns } from "./storeByServiceList.vue?vue&type=template&id=56d8aafc&scoped=true"
import script from "./storeByServiceList.vue?vue&type=script&lang=js"
export * from "./storeByServiceList.vue?vue&type=script&lang=js"
import style0 from "./storeByServiceList.vue?vue&type=style&index=0&id=56d8aafc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d8aafc",
  null
  
)

export default component.exports